import React, { useEffect, useState } from "react";
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Space, Table, Typography } from "antd";
import { CloseOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import { FORMAT_DATE, LIST_UNITS, requiredItem, TYPE_EXPORT, TYPE_MODAL } from "../../../constants/constants";
import { filterOption, formatInputNumber, parseInputNumber } from "../../../utils/funcHelper";
import dayjs from "dayjs";
import { consoleLogUtil } from "../../../utils/consoleLogUtil";
import DebounceSelect from "../../../components/DebounceSelect";
import { getListCustomers, product_search_for_export } from "../../../services/apis";
import DebounceSelectProduct from "../../../components/DebounceSelectProduct";

const { Title, Text } = Typography;

const ModalExportOrder = ({ visible, onCancel, onSave, warehouses, products, type, data, title, employees }) => {
    const [form] = Form.useForm();
    const [productList, setProductList] = useState([]);
    const [typeExport, setTypeExport] = useState(null);
    const [warehouse_id, setWarehouseId] = useState(null);
    const columns_add = [
        {
            title: "Tên sản phẩm",
            dataIndex: "product_id",
            key: "product_id",
            width: "35%",
            render: (value, record) => (
                <DebounceSelectProduct
                    placeholder="Chọn sản phẩm"
                    fetchOptions={findProducts}
                    onClear={() => onClearCustomer()}
                    style={{ width: '100%', height: 32, textAlign: 'left', display: 'block' }}
                    onChange={(val, option) => {
                        consoleLogUtil("Selected value:", val);
                        consoleLogUtil("Selected option:", option);

                        // option có thể là mảng (nhiều lựa chọn) hoặc object (một lựa chọn)
                        handleUpdateProduct(record.key, "product_id", val, option);
                    }}
                    disabled={type === TYPE_MODAL.EDIT}
                />
            ),
        },
        {
            title: "Đơn vị tính",
            dataIndex: "unit",
            key: "unit",
            align: "center",
            width: "10%",
            render: (value, record) => (
                <Text>{record?.unit_name}</Text>
            ),
        },
        {
            title: "Tồn",
            dataIndex: "stock_quantity",
            key: "stock_quantity",
            align: "center",
            width: "10%",
            render: (value, record) => (
                <Text>{record?.stock_quantity}</Text>
            ),
        },
        {
            title: "Số lượng",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
            width: "10%",
            render: (value, record) => (
                <InputNumber
                    min={0}
                    value={value}
                    onChange={(val) => handleUpdateProduct(record.key, "quantity", val)}
                    style={{ width: "100%" }}
                    className="input-number-right"
                    disabled={type === TYPE_MODAL.EDIT}
                    max={record?.stock_quantity || 0}
                />
            ),
        },
        {
            title: "Giá bán (vnd)",
            dataIndex: "sell_price",
            key: "sell_price",
            width: "15%",
            align: "center",
            render: (value, record) => (
                <InputNumber
                    min={0}
                    value={value}
                    formatter={formatInputNumber}
                    parser={parseInputNumber}
                    onChange={(val) => handleUpdateProduct(record.key, "sell_price", val)}
                    style={{ width: "100%" }}
                    className="input-number-right"
                    disabled={type === TYPE_MODAL.EDIT}
                />
            ),
        },
        {
            title: "Thành tiền (vnd)",
            dataIndex: "total",
            key: "total",
            width: "15%",
            align: "center",
            render: (value) => <div style={{ textAlign: 'end' }}><strong><Text>{formatInputNumber(value)}</Text></strong></div>,
        },
        {
            title: "Hành động",
            dataIndex: "action",
            key: "action",
            align: "center",
            render: (_, record) => (
                type === TYPE_MODAL.EDIT ? null :
                    <Button
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => handleRemoveProduct(record.key)}
                        size="small"
                        style={{ height: 28 }}
                    />
            ),
        },
    ];
    const columns_edit = [
        {
            title: "Tên sản phẩm",
            dataIndex: "product_id",
            key: "product_id",
            width: "40%",
            render: (value, record) => (
                <Select
                    showSearch
                    placeholder="Chọn sản phẩm"
                    value={value}
                    filterOption={filterOption}
                    options={products || []}
                    style={{ width: "100%" }}
                    disabled={type === TYPE_MODAL.EDIT}
                />
            ),
        },
        {
            title: "Đơn vị tính",
            dataIndex: "unit",
            key: "unit",
            align: "center",
            width: "10%",
            render: (value, record) => (
                <Text>{record?.unit_name}</Text>
            ),
        },
        {
            title: "Số lượng",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
            width: "10%",
            render: (value, record) => (
                <InputNumber
                    min={0}
                    value={value}
                    onChange={(val) => handleUpdateProduct(record.key, "quantity", val)}
                    style={{ width: "100%" }}
                    className="input-number-right"
                    disabled={type === TYPE_MODAL.EDIT}
                    max={record?.stock_quantity || 0}
                />
            ),
        },
        {
            title: "Giá bán (vnd)",
            dataIndex: "sell_price",
            key: "sell_price",
            width: "15%",
            align: "center",
            render: (value, record) => (
                <InputNumber
                    min={0}
                    value={value}
                    formatter={formatInputNumber}
                    parser={parseInputNumber}
                    onChange={(val) => handleUpdateProduct(record.key, "sell_price", val)}
                    style={{ width: "100%" }}
                    className="input-number-right"
                    disabled={type === TYPE_MODAL.EDIT}
                />
            ),
        },
        {
            title: "Thành tiền (vnd)",
            dataIndex: "total",
            key: "total",
            width: "15%",
            align: "center",
            render: (value) => <div style={{ textAlign: 'end' }}><strong><Text>{formatInputNumber(value)}</Text></strong></div>,
        },
        {
            title: "Hành động",
            dataIndex: "action",
            key: "action",
            align: "center",
            render: (_, record) => (
                type === TYPE_MODAL.EDIT ? null :
                    <Button
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => handleRemoveProduct(record.key)}
                        size="small"
                        style={{ height: 28 }}
                    />
            ),
        },
    ];
    consoleLogUtil("data in modal", data);
    // Xử lý khi nhấn "Lưu"
    const handleFinish = (values) => {
        const data = {
            ...values,
            export_date: values.export_date ? values.export_date.format(FORMAT_DATE.YYYYMMDD) : null,
            branch_id: warehouses.find(wh => wh.value.toString() === values.warehouse_id)?.branch_id || null,
            items: productList,
            customer_id: values.customer_id ? values.customer_id.value : null,
            discount_amount: Number(values?.discount_amount || 0)
        };
        if (data.items.length === 0) {
            Modal.error({
                title: "Lỗi",
                content: "Vui lòng thêm ít nhất một sản phẩm vào danh sách.",
            });
            return;
        }
        onSave(data);
    };

    // Xử lý khi thay đổi loại xuất
    const handleChangePurpose = (value) => {
        setTypeExport(value);
    }

    // Thêm sản phẩm vào danh sách
    const handleAddProduct = () => {
        setProductList([
            ...productList,
            {
                key: productList.length + 1,
                product_id: null,
                unit: null,
                quantity: 0,
                sell_price: 0,
                total: 0,
            },
        ]);
    };

    // Xóa sản phẩm khỏi danh sách
    const handleRemoveProduct = (key) => {
        setProductList(productList.filter((item) => item.key !== key));
    };

    const onClearCustomer = () => {

    }

    // Cập nhật giá trị sản phẩm
    const handleUpdateProduct = (key, field, value, option) => {
        const updatedList = productList.map((item) => {
            if (item.key === key) {
                const updatedItem = { ...item, [field]: value };
                consoleLogUtil("option", option);
                // Tự động gán đơn vị khi chọn sản phẩm
                if (field === "product_id") {
                    const unitId = option?.product?.unit ?? null;
                    const unitName = LIST_UNITS.find((unit) => unit.value === unitId)?.label || "";
                    updatedItem.unit = unitId;
                    updatedItem.unit_name = unitName;
                    updatedItem.stock_quantity = option?.product?.stock_quantity || 0;
                    updatedItem.sell_price = option?.product?.sell_price ? parseInt(option.product?.sell_price) : 0;
                    updatedItem.total = (updatedItem.quantity || 0) * (updatedItem.sell_price || 0);
                    updatedItem.product_id = value?.value;
                }

                if (field === "quantity" || field === "sell_price") {
                    updatedItem.total = (updatedItem.quantity || 0) * (updatedItem.sell_price || 0);
                }
                return updatedItem;
            }
            return item;
        });
        setProductList(updatedList);
    };
    const discountAmount = Form.useWatch('discount_amount', form) || 0;
    // Tính tổng số lượng và tổng giá trị
    const calculateTotals = () => {
        const totalQuantity = productList.reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);
        const totalValue = productList.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
        const finalTotalValue = totalValue - discountAmount;
        return { totalQuantity, finalTotalValue };
    };

    const { totalQuantity, finalTotalValue } = calculateTotals();
    const paymentSummary = data?.order?.payment_summary || {};
    const paidAmountInitial = paymentSummary?.paid_amount_initial ?? 0;
    const debtInitial = paymentSummary?.debt_initial ?? 0;
    const totalDebtPaid = paymentSummary?.total_debt_paid ?? 0;
    const debtRemaining = paymentSummary?.debt_remaining ?? 0;

    const findCustomers = async (keyword) => {
        try {
            const params = {
                keyword: keyword,
                limit: 100,
                currentPage: 1,
            };
            const response = await getListCustomers(params); // Gọi API
            const results = response?.data?.data || []; // Lấy dữ liệu từ API
            return results.map((customer) => ({
                label: customer.full_name, // Hiển thị tên khách hàng
                value: customer.id, // Giá trị là ID khách hàng
                customer, // Truyền toàn bộ đối tượng khách hàng nếu cần
            }));
        } catch (error) {
            console.error("Error fetching customers:", error);
            return []; // Trả về mảng rỗng nếu có lỗi
        }
    };

    const findProducts = async (keyword) => {
        try {
            const params = {
                keyword: keyword,
                warehouse_id: form.getFieldValue('warehouse_id'),
                limit: 100
            };
            const response = await product_search_for_export(params); // Gọi API
            const results = response?.data || []; // Lấy dữ liệu từ API
            return results.map((product) => ({
                label: product.product_name, // Hiển thị tên khách hàng
                value: product.product_id, // Giá trị là ID khách hàng
                product, // Truyền toàn bộ đối tượng khách hàng nếu cần
            }));
        } catch (error) {
            console.error("Error fetching customers:", error);
            return []; // Trả về mảng rỗng nếu có lỗi
        }
    };

    const handleChangePayment = (value) => {
        const totalValue = productList.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
        const debt = totalValue - discountAmount - (value || 0);
        form.setFieldsValue({
            debt_amount: debt >= 0 ? debt : 0
        });
    }

    // Tự động tính lại tiền nợ khi thay đổi giảm giá hoặc danh sách sản phẩm
    useEffect(() => {
        if (type !== TYPE_MODAL.ADD) return; // chỉ áp dụng khi tạo mới
        const totalValue = productList.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
        const paid = Number(form.getFieldValue('paid_amount') || 0);
        const discount = Number(discountAmount || 0);
        const debt = Math.max(0, totalValue - discount - paid);
        form.setFieldsValue({ debt_amount: debt });
    }, [discountAmount, productList, form, type]);

    useEffect(() => {
        if (type === TYPE_MODAL.ADD) {
            form.resetFields();
            setProductList([]);
        } else {
            setTypeExport(data?.order?.purpose || null);
            form.setFieldsValue({
                notes: data?.order?.notes,
                export_date: data?.order?.export_date ? dayjs(data?.order?.export_date, FORMAT_DATE.YYYYMMDD) : null,
                purpose: TYPE_EXPORT.find(item => item.value === data?.order?.purpose)?.value || null,
                customer_name: data?.order?.customer?.name || "",
                discount_amount: data?.order?.discount_amount || 0
            });
            const initialProducts = (data?.items || []).map((item, index) => ({
                key: index + 1,
                product_id: item.product_id,
                unit: products.find(prod => prod.value === item.product_id)?.unit || null,
                unit_name: LIST_UNITS.find(unit => unit.value === products.find(prod => prod.value === item.product_id)?.unit)?.label || "",
                quantity: item.quantity,
                sell_price: item.sell_price,
                total: item.quantity * (item.sell_price ? parseInt(item.sell_price) : 0),
            }));
            setProductList(initialProducts);
        }
    }, [visible, data])

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT && warehouses.length > 0) {
            form.setFieldsValue({
                warehouse_id: data?.order?.warehouse_id ? data?.order?.warehouse_id?.toString() : null
            });
        }
    }, [visible, warehouses])

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT && employees.length > 0) {
            form.setFieldsValue({
                consultants: data?.order?.consultants ? data?.order?.consultants.map(emp => emp?.id) : []
            });
        }
    }, [visible, employees])

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={"80%"}
            footer={null}
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                {/* Khu vực thông tin chung */}
                <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                    <Title level={5}>Thông tin chung</Title>
                    <Row gutter={16}>
                        <Col span={4}>
                            <Form.Item
                                label="Kho"
                                name="warehouse_id"
                                rules={requiredItem}
                            >
                                <Select
                                    placeholder="Chọn kho"
                                    options={warehouses || []}
                                    disabled={type === TYPE_MODAL.EDIT}
                                    onChange={(value) => setWarehouseId(value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label="Ngày xuất"
                                name="export_date"
                                rules={requiredItem}
                            >
                                <DatePicker
                                    format={FORMAT_DATE.DDMMYYYY}
                                    style={{ width: "100%" }}
                                    disabled={type === TYPE_MODAL.EDIT}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label="Tư vấn viên"
                                name="consultants"
                            >
                                <Select
                                    showSearch
                                    mode="multiple"
                                    maxTagCount={'responsive'}
                                    filterOption={filterOption}
                                    placeholder="Chọn nhân viên"
                                    options={employees || []}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={10}>
                            <Form.Item
                                label="Ghi chú"
                                name="notes"
                            >
                                <Input style={{ height: 32 }} disabled={type === TYPE_MODAL.EDIT} />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label="Loại xuất"
                                name="purpose"
                                rules={requiredItem}
                            >
                                <Select
                                    placeholder="Chọn loại xuất"
                                    options={TYPE_EXPORT || []}
                                    disabled={type === TYPE_MODAL.EDIT}
                                    onChange={(value) => handleChangePurpose(value)}
                                />
                            </Form.Item>
                        </Col>
                        {
                            typeExport === TYPE_EXPORT[0].value && type === TYPE_MODAL.ADD ?
                                <Col span={8}>
                                    <Form.Item
                                        label="Chọn khách hàng"
                                        name="customer_id"
                                        rules={requiredItem}
                                    >
                                        <DebounceSelect
                                            placeholder="Tìm kiếm khách hàng"
                                            fetchOptions={findCustomers}
                                            onClear={() => onClearCustomer()}
                                            style={{ width: '100%', height: 32, textAlign: 'left', display: 'block' }}
                                            onChange={(newValue, option) => {
                                                consoleLogUtil("Selected value:", newValue);
                                                consoleLogUtil("Selected option:", option);

                                                // option có thể là mảng (nhiều lựa chọn) hoặc object (một lựa chọn)
                                                const customer = option?.customer;
                                            }}
                                        />
                                    </Form.Item>
                                </Col> : null
                        }
                        {
                            typeExport === TYPE_EXPORT[0].value && type === TYPE_MODAL.EDIT ?
                                <Col span={8}>
                                    <Form.Item
                                        label="Khách hàng"
                                        name="customer_name"
                                    >
                                        <Input
                                            style={{ height: 32 }}
                                            disabled
                                        />
                                    </Form.Item>
                                </Col> : null
                        }
                        {
                            typeExport === TYPE_EXPORT[0].value ?
                                <>
                                    <Col span={3}>
                                        <Form.Item
                                            name="discount_amount"
                                            label="Giảm giá (VNĐ)"
                                        >
                                            <InputNumber
                                                min={0}
                                                className="input-number-cus-ant"
                                                formatter={formatInputNumber}
                                                parser={parseInputNumber}
                                                style={{ width: 50 }}
                                                disabled={type === TYPE_MODAL.EDIT}
                                            />
                                        </Form.Item>
                                    </Col>
                                    {
                                        type === TYPE_MODAL.EDIT ? null :
                                            <>
                                                <Col span={4}>
                                                    <Form.Item
                                                        name="paid_amount"
                                                        label="Đã thanh toán (VNĐ)"
                                                        rules={requiredItem}
                                                    >
                                                        <InputNumber
                                                            min={0}
                                                            className="input-number-cus-ant"
                                                            formatter={formatInputNumber}
                                                            parser={parseInputNumber}
                                                            onChange={(value) => handleChangePayment(value)}
                                                            style={{ width: 50 }}
                                                            disabled={type === TYPE_MODAL.EDIT}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4}>
                                                    <Form.Item
                                                        name="debt_amount"
                                                        label="Còn nợ (VNĐ)"
                                                    >
                                                        <InputNumber
                                                            min={0}
                                                            className="input-number-cus-ant"
                                                            formatter={formatInputNumber}
                                                            parser={parseInputNumber}
                                                            style={{ width: 50 }}
                                                            disabled

                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </>
                                    }

                                </> : null

                        }

                    </Row>
                </Card>

                {/* Khu vực danh sách sản phẩm */}
                <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                    <Title level={5}>Danh sách sản phẩm</Title>
                    <Table
                        dataSource={productList}
                        pagination={false}
                        rowKey="key"
                        bordered
                        columns={type === TYPE_MODAL.EDIT ? columns_edit : columns_add}
                    />
                    {
                        type === TYPE_MODAL.EDIT ? null :
                            <Button
                                type="dashed"
                                onClick={handleAddProduct}
                                block
                                icon={<PlusOutlined />}
                                style={{ marginTop: 16 }}
                                disabled={!warehouse_id}
                            >
                                Thêm sản phẩm
                            </Button>
                    }

                </Card>

                {type === TYPE_MODAL.EDIT ? (
                    <Card size="small" style={{ marginBottom: 16, borderRadius: 8 }}>
                        <Title level={5}>Thông tin thanh toán</Title>
                        <Row gutter={16}>
                            <Col span={6}>
                                <Text><strong>Thanh toán lần đầu:</strong> {formatInputNumber(paidAmountInitial)} VNĐ</Text>
                            </Col>
                            <Col span={6}>
                                <Text><strong>Nợ đầu:</strong> {formatInputNumber(debtInitial)} VNĐ</Text>
                            </Col>
                            <Col span={6}>
                                <Text><strong>Số nợ đã trả:</strong> {formatInputNumber(totalDebtPaid)} VNĐ</Text>
                            </Col>
                            <Col span={6} style={{ textAlign: "right" }}>
                                <Text><strong>Nợ còn lại:</strong> <span style={{ color: "red" }}>{formatInputNumber(debtRemaining)} VNĐ</span></Text>
                            </Col>
                        </Row>
                    </Card>
                ) : null}

                {/* Khu vực tổng cộng */}
                <Card size="small" style={{ borderRadius: 8 }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Text strong>Tổng số lượng: {totalQuantity}</Text>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <Text strong>Tổng giá trị: {formatInputNumber(finalTotalValue)} VNĐ</Text>
                        </Col>
                    </Row>
                </Card>

                {/* Nút hành động */}
                <Row justify="end" style={{ marginTop: 16 }}>
                    <Space>
                        <Button onClick={onCancel} icon={<CloseOutlined />}>
                            Đóng
                        </Button>
                        {
                            type === TYPE_MODAL.EDIT ? null :
                                <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                                    Lưu
                                </Button>
                        }

                    </Space>
                </Row>
            </Form>
        </Modal>
    );
};

export default React.memo(ModalExportOrder);
